import React from "react";
// import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { AppProvider } from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import App from "./App";
import store from "./store/index";
import "./index.css";

import "./utils/fonts/Pacifico/Pacifico-Regular.ttf";
import "./utils/fonts/Montserrat/Montserrat-VariableFont_wght.ttf";

import { isRunningStandalone, getEmbeddedShopDomain } from "./utils/embeddedAppUtils";
import LegacyStandaloneNotice from "./components/UI/LegacyStandaloneNotice";

// Capture ?shop= and the signed hmac query before routing/App Bridge can drop them.
getEmbeddedShopDomain();

/*
  Recover from stale lazy-loaded chunks after dependency updates or dev-server restarts.
  Example: ChunkLoadError for vendors-node_modules_shopify_polaris_...chunk.js

  Also ignore benign ResizeObserver loop notifications — browsers fire them when a
  resize callback causes more layout in the same frame; CRA's overlay otherwise
  treats them as a fatal runtime error.
*/
window.addEventListener(
  "error",
  (event) => {
  const message = event?.message ?? "";

  if (
    message.includes("ResizeObserver loop") ||
    message.includes("ResizeObserver loop limit exceeded")
  ) {
    event.stopImmediatePropagation();
    return;
  }

  const isChunkError =
    message.includes("Loading chunk") || event?.error?.name === "ChunkLoadError";

  if (!isChunkError) {
    return;
  }

  const reloadKey = "chunk-reload-attempted";
  if (!sessionStorage.getItem(reloadKey)) {
    sessionStorage.setItem(reloadKey, "1");
    window.location.reload();
    return;
  }

  sessionStorage.removeItem(reloadKey);
},
  true
);

// import '@shopify/polaris/dist/styles.css';
const container = document.getElementById('root');
const root = createRoot(container);

/*
 * The app now only works embedded inside Shopify Admin -- authentication is
 * entirely App Bridge session-token based (no more localStorage JWT). If we're not
 * embedded, skip booting the app (and App Bridge/any /api call) entirely and show a
 * notice instead.
 *
 * Note: a tab already open with the pre-cutover bundle before this deploy can't be
 * retroactively caught here -- only a fresh page load runs this check.
 */
if (isRunningStandalone()) {
  root.render(<LegacyStandaloneNotice />);
} else {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <AppProvider i18n={en}>
          <App />
        </AppProvider>
      </BrowserRouter>
    </Provider>
  );
}
